import { msg } from '@lingui/core/macro';
import { MessageDescriptor } from '@lingui/core';
import * as React from 'react';
import { useLingui } from '@lingui/react';
import Star from './Star';

type StarLabel = MessageDescriptor[];

const starLabels: StarLabel = [msg`Poor`, msg`Below Average`, msg`Average`, msg`Good`, msg`Excellent`];

export type StarRatingProps = {
  question: string;
  onSubmit: (starsNumber: number) => void;
};

const StarRating: React.FC<StarRatingProps> = ({ question, onSubmit }: StarRatingProps) => {
  const [hoveredStarIndex, setHoveredStarIndex] = React.useState<number>(-1);
  const { _ } = useLingui();

  const onStarSubmit = (starsIndex: number) => {
    onSubmit(starsIndex + 1);
  };

  return (
    <div>
      <h3 className="text-center">{question}</h3>
      <div className="mx-7 mb-3 mt-5 flex justify-evenly">
        {starLabels.map((label, index) => (
          <Star
            key={_(label)}
            isFilled={hoveredStarIndex >= index}
            onMouseEnter={() => setHoveredStarIndex(index)}
            onMouseLeave={() => setHoveredStarIndex(-1)}
            onSubmit={() => onStarSubmit(index)}
            data-testid={`star-rating-star-${index + 1}`}
          />
        ))}
      </div>
      <div className="mt-4 h-7 text-center">{hoveredStarIndex > -1 ? _(starLabels[hoveredStarIndex]) : ''}</div>
    </div>
  );
};

export default StarRating;
